var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Down",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.20713 15.7071C1.8166 16.0976 1.18344 16.0976 0.792905 15.7071C0.402385 15.3166 0.402385 14.6834 0.792905 14.2929L7.08582 8L0.792905 1.7071C0.402385 1.3166 0.402385 0.6834 0.792905 0.2929C1.18343 -0.0975991 1.81659 -0.0975991 2.20712 0.2929L9.20711 7.2929C9.59761 7.6834 9.59761 8.31658 9.20711 8.70711L2.20713 15.7071Z",
    fill: "#A06056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/Arrow__right.6f37a1a890378d3bb3d20dcaed73fba4.svg";
export { ForwardRef as ReactComponent };